import LinkWithParams from "components/elements/LinkWithParams";
import { useGetZammadBaseLinkQuery } from "store/masterdata";
import styles from "./MenuCard.module.less";

interface Props {
  Icon?: React.ReactNode | null;
  title: string;
  description?: string;
  to: string;
  external?: boolean;
}

function MenuCard({
  Icon,
  title,
  description,
  to,
  external,
}: Props): JSX.Element {
  const { data: zammadBaseLink } = useGetZammadBaseLinkQuery();

  if (external) {
    return (
      <a
        className={styles.wrapper}
        href={to === "fromAPI" ? zammadBaseLink : to}
        target="_blank"
        rel="noreferrer"
      >
        <div className={styles.icon}>{Icon}</div>
        <p className={styles.title}>{title}</p>
        <p className={styles.description}>{description}</p>
      </a>
    );
  }

  return (
    <LinkWithParams to={to} className={styles.wrapper}>
      <div className={styles.icon}>{Icon}</div>
      <p className={styles.title}>{title}</p>
      <p className={styles.description}>{description}</p>
    </LinkWithParams>
  );
}

export default MenuCard;
